import { useEffect, useRef, useState } from "react";
import { ArrowUpRight, AudioLines, Menu, X } from "lucide-react";
import { tour } from "../lib/tour";

const links = [
  { id: "band", label: "The band" },
  { id: "shows", label: "Shows & tour" },
  { id: "photos", label: "On the road" },
];

export function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("home");
  const menuButton = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) setActiveSection(entry.target.id);
      }
    }, { rootMargin: "-15% 0px -65% 0px" });
    for (const id of ["home", ...links.map((link) => link.id), "support"]) {
      const section = document.getElementById(id);
      if (section) observer.observe(section);
    }
    return () => observer.disconnect();
  }, []);

  return (
    <header
      className="site-header"
      onKeyDown={(event) => {
        if (event.key === "Escape" && menuOpen) {
          setMenuOpen(false);
          menuButton.current?.focus();
        }
      }}
    >
      <div className="shell header-inner">
        <a className="wordmark" href="#home" aria-label="School of Rock Lakewood Ranch House Band home" onClick={() => setMenuOpen(false)}>
          <AudioLines aria-hidden="true" />
          <span><strong>School of Rock</strong><small>Lakewood Ranch / House Band</small></span>
        </a>
        <nav className="desktop-nav" aria-label="Main navigation">
          {links.map((link) => (
            <a key={link.id} href={`#${link.id}`} aria-current={activeSection === link.id ? "location" : undefined}>
              {link.label}
            </a>
          ))}
        </nav>
        <a className="button button-primary header-support" href={tour.fundraiserUrl} target="_blank" rel="noopener noreferrer">
          Support the tour <ArrowUpRight aria-hidden="true" />
        </a>
        <button
          ref={menuButton}
          className="icon-button menu-toggle"
          type="button"
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          aria-expanded={menuOpen}
          aria-controls="mobile-navigation"
          onClick={() => setMenuOpen((open) => !open)}
        >
          {menuOpen ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
        </button>
      </div>
      <nav id="mobile-navigation" className="mobile-nav shell" aria-label="Mobile navigation" hidden={!menuOpen}>
        {links.map((link) => (
          <a key={link.id} href={`#${link.id}`} aria-current={activeSection === link.id ? "location" : undefined} onClick={() => setMenuOpen(false)}>
            {link.label} <ArrowUpRight aria-hidden="true" />
          </a>
        ))}
        <a href="#support" onClick={() => setMenuOpen(false)}>Be part of the tour <ArrowUpRight aria-hidden="true" /></a>
      </nav>
    </header>
  );
}
